import {
  MarketSearchResponse,
  UserRoleListType,
} from "../../api/services/manageUser/models";
import { OptionsDataType, RowProps } from "../../components";
import { WEEK_DAYS } from "../../helpers/constants";
import { LabelValue } from "../../helpers/types/common";
import { isNotEmpty } from "../../helpers/utils";
import {
  MarketRegions,
  ServiceOfficeType,
  TransformedRegionMarketData,
  USER_ROLE_TYPES,
} from "./modelsAndSchemas/models";

export const getServiceOfficeList = (
  serviceOfficeListByCountryCodes: ServiceOfficeType[],
) => {
  let serviceOfficeList: OptionsDataType[] = [];
  if (isNotEmpty(serviceOfficeListByCountryCodes)) {
    serviceOfficeList = serviceOfficeListByCountryCodes.map(
      (country: ServiceOfficeType) => ({
        label: country.rightOfficeName,
        value: country.rightOfficeId,
      }),
    );
  }
  return serviceOfficeList;
};

export const userSelectedRoleData = (
  selectedRoles: string[],
  allRoleList: UserRoleListType[],
) => {
  if (isNotEmpty(selectedRoles) && isNotEmpty(allRoleList)) {
    return allRoleList
      .filter((role: UserRoleListType) =>
        selectedRoles.includes(role.value as string),
      )
      .map((role: UserRoleListType) => ({
        role: role.label,
        roleId: role.value,
      }));
  }
  return [];
};

export const regionMarketGroupedTableData = (
  rowData: RowProps,
  regionData: LabelValue[],
  marketData: MarketSearchResponse[],
) => {
  const regionList = rowData?.salesRegion
    ?.map((regionId: string) => {
      const region = regionData.find((r: LabelValue) => r.value === regionId);
      if (!region) return null;

      const markets = marketData
        .filter(
          (m: MarketSearchResponse) =>
            m.region.id === regionId && rowData.salesMarket?.includes(m.id),
        )
        .map((m: MarketSearchResponse) => ({
          name: m.name,
          value: m.id,
        }));

      return {
        name: region.label,
        value: regionId,
        children: markets,
      };
    })
    .filter(Boolean);

  return regionList;
};

export const transformRegionMarketBySelection = (
  regionMarket: MarketRegions[],
  selectedRegionIds: string[],
  selectedMarketIds: string[],
): TransformedRegionMarketData[] => {
  const grouped = new Map<string, TransformedRegionMarketData>();

  regionMarket?.forEach(({ salesRegionId, salesRegionName, id, name }) => {
    const isRegionSelected = selectedRegionIds.includes(salesRegionId);
    const isMarketSelected = selectedMarketIds.includes(id);

    if (!isRegionSelected || !isMarketSelected) return;

    if (!grouped.has(salesRegionId)) {
      grouped.set(salesRegionId, {
        name: salesRegionName,
        value: salesRegionId,
        children: [],
      });
    }

    grouped.get(salesRegionId)!.children.push({
      name,
      value: id,
    });
  });

  return Array.from(grouped.values());
};

export const sortDaysByWeekOrder = (days: string[]): string[] => {
  const weekDayOrder = WEEK_DAYS.map((day) => day.value);

  return [...days].sort(
    (a, b) =>
      weekDayOrder.indexOf(a.toLowerCase()) -
      weekDayOrder.indexOf(b.toLowerCase()),
  );
};

export const isRoleTypeAll = (roleType?: string) =>
  isNotEmpty(roleType) && roleType === USER_ROLE_TYPES.ALL;
export const isRoleTypeClientPortal = (roleType?: string) =>
  isNotEmpty(roleType) && roleType === USER_ROLE_TYPES.CLIENT_PORTAL;
export const isRoleTypeCirrusP3AndCandidatePortal = (roleType?: string) =>
  isNotEmpty(roleType) &&
  roleType === USER_ROLE_TYPES.CIRRUS_P3_AND_CANDIDATE_PORTAL;